import { useState, useEffect } from 'react';
import { LOADING_EMOJIS } from '../utils/scoreColors';

export default function CalculatingLoader() {
  const [emojiIndex, setEmojiIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setEmojiIndex((i) => (i + 1) % LOADING_EMOJIS.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center gap-3">
      <span className="text-4xl">{LOADING_EMOJIS[emojiIndex]}</span>
      <p className="text-ink-light font-body font-medium">Calculating...</p>
    </div>
  );
}
